module.exports = __webpack_public_path__ + "img/LowStandardDeviation.1c9d5b5f.png";